import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowPathLeft"><Path d="M10.9995 3.125V8.00047H21.9995V16.0005H10.9995V20.8759L0.59375 12.0005L10.9995 3.125Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathLeft;
